import React from 'react'
import AppLayout from 'components/layout/layout'
import { useParams } from 'react-router-dom'
import BreadCrumbs from 'components/global/BreadCrumbs'
import { capitalizeFirstLetter } from 'helper/utility'
import { Button } from 'antd'
import CommunitiesTables from './Components/CommunitiesTables'
import CommunitySchoolModal from './Modals/CommunitySchoolModal'
import { CommunitySchoolStore } from 'state/setting/communitySchool'

const ManageCommunities: React.FC = () => {
  const { id }: { id: string } = useParams()
  const {
    setCommunitySchoolData,
    addCommunitySchoolModal,
    setAddCommunitySchoolModal,
  } = CommunitySchoolStore(store => ({
    setCommunitySchoolData: store.setCommunitySchoolData,
    addCommunitySchoolModal: store.addCommunitySchoolModal,
    setAddCommunitySchoolModal: store.setAddCommunitySchoolModal,
  }))

  const handleNew = () => {
    setCommunitySchoolData(undefined)
    setAddCommunitySchoolModal(true)
  }
  return (
    <AppLayout id={id}>
      <div className="container px-40px py-40px scroller overflow-auto-y">
        <div className="mb-20px">
          <BreadCrumbs
            links={[
              {
                name: 'Settings',
                link: '/settings?tab=GeneralSetting',
              },
              {
                name: `Manage Communities`,
                link: `/manage-communities`,
              },
            ]}
          />
        </div>

        <div className="flex align-center justify-between">
          <h3 className="text-24 w-600">Manage Communities</h3>
          <Button className={'btn-new primary br-8'} onClick={handleNew}>
            Add New
          </Button>
        </div>

        <div className="mt-20px">
          <CommunitiesTables id={id} />
        </div>
      </div>
      {addCommunitySchoolModal && <CommunitySchoolModal />}
    </AppLayout>
  )
}

export default ManageCommunities
